import { toast } from "@gigpro/ui/Toast";

export async function copyToClipboard(text: string, successToast?: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    toast.error("Couldn't copy to clipboard");
    return false;
  }
  if (successToast) toast.success(successToast);
  return true;
}
